var render, staticRenderFns
import script from "./topMenuPopover.vue?vue&type=script&lang=js&"
export * from "./topMenuPopover.vue?vue&type=script&lang=js&"
import style0 from "./topMenuPopover.vue?vue&type=style&index=0&id=4a27c8b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a27c8b0",
  null
  
)

export default component.exports